module.exports = __webpack_public_path__ + "static/media/Punto5_Portada.3cc0a45c.png";